import $http from '@/0/Libs/HttpHelper.js'
import $msg from '@/0/Libs/MessageHelper.js'

export default {


  //获取地理位置
  async getGpsItem(lng, lat) {

    var url = "/SysApi/Lbs/GetGps";
    var postData = {
      lng: lng,
      lat: lat,
    };
    let { data: result } = await $http.post(url, postData);
    console.log("GetGps", result);
    if (result.state == 1) {
      var gpsItem = result.data;
      return gpsItem;
    }
    return null;
  },

}